import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Pagination } from '@mui/material';
import BlogCard from "../components/BlogCard";
import Header from "../components/Header";
import {SectionTitle} from "../components/SectionTitle";
import { theme } from "../Template";

const Blog = () => {
  return (
    <div>
      <Header />
      <BlogList />
    </div>
  );
};

const BlogList = () => {
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box py={5} width="90%" margin="auto">
      <SectionTitle>Our Articles</SectionTitle>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent={matches ? "space-between" : "center"}
      >
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
      </Box>
      <Box py={4} display="flex" justifyContent="center">
        <Pagination size="large" color="primary" count={10} />
      </Box>
    </Box>
  );
};

export default Blog;
